import { FC } from 'react';
import useNotifications from 'hooks/useNotifications';

const NotificationManager: FC = () => {
  useNotifications();
  return null;
};

export default NotificationManager;
